import Vue from 'vue'
import Vuex from 'vuex'
import * as user from './modules/user'
import * as cards from './modules/cards'
import * as modal from './modules/modal'
import * as alerts from './modules/alerts'
import * as client from './modules/client'
import * as clients from './modules/clients'
import * as templates from './modules/templates'
import * as categories from './modules/categories'
import * as checklists from './modules/checklists'
import * as notifications from './modules/notifications'
import * as cardCatalogue from './modules/card-catalogue'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    cards,
    modal,
    client,
    alerts,
    clients,
    templates,
    checklists,
    categories,
    notifications,
    cardCatalogue,
  },
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {},
})
